<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ២.ក
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.គ​,ឃ,ង,ច,ឆ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <studentlow :data="stu_low" :curacc="cur_acc" :title="title[1]" />
            <studentupp :data="stu_upp" :curacc="cur_acc" :title="title[2]" />
          </div>
          <div v-if="false">
            <studentTec :data="stu_tec" :curacc="cur_acc" :title="title[3]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <dissec :data="dis_sec" type="3" :title="title[4]" />
            <!-- 2 for pri, 3.4.5 for sec -->
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <ethnicsec
              :ethlow="eth_low"
              :ethhigh="eth_upp"
              :tente="tte_ntt"
              :title="title[5]"
            />
          <div>
            <lowmigration :data="sec_lsms" :curacc="cur_acc" :title="title[6]" ctitle="(ចំនួនសិស្សភៀសសឹក)"/>
          </div>
          <div>
            <uppmigration :data="sec_usms" :title="title[7]" ctitle="សិស្សភៀសសឺក"/>
          </div>
            <laststusec
              :data="lst_sec"
              :cur_cod="cur_cod"
              :curacc="cur_acc"
              :lastacc="lst_acc"
              :title="title[7]"
            />
            <reentrysec :data="stu_rep" :title="title[8]" />
            <resultSec :data="lr_sec" :lastacc="lst_acc" :title="title[9]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import studentLow from "@/components/ascf/sec/studentLow.vue";
import lowMigration from "@/components/ascf/sec/lowMigration.vue";
import studentUpp from "@/components/ascf/sec/studentUppTs.vue";
import uppMigration from "@/components/ascf/sec/uppMigration.vue";
import studentTec from "@/components/ascf/sec/studentTec.vue";
import dissec from "@/components/ascf/sharedCom/disable.vue";
import ethnicSec from "@/components/ascf/sec/ethnicSec.vue";
import lastStuSec from "@/components/ascf/sec/laststuSec.vue";
import reentrysec from "@/components/ascf/sec/reentrySec.vue";
import resultsec from "@/components/ascf/sharedCom/sResult.vue";

export default {
  props: [
    "title",
    "stu_low",
    "stu_upp",
    "stu_tec",
    "dis_sec",
    "eth_low",
    "eth_upp",
    "tte_ntt",
    "lst_sec",
    "stu_rep",
    "lr_sec",
    "sec_lsms",
    "sec_usms",
    "type_code",
    "tecOnOff",
    "cur_cod",
    "lst_acc",
    "cur_acc",
  ],
  components: {
    studentlow: studentLow,
    studentupp: studentUpp,
    studentTec: studentTec,
    dissec: dissec,
    ethnicsec: ethnicSec,
    laststusec: lastStuSec,
    reentrysec: reentrysec,
    resultSec: resultsec,
    lowmigration: lowMigration,
    uppmigration: uppMigration
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>

<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>